export const getApiErrorMessage = (error: any, fallback: string): string =>
  error?.error?.message || error?.message || fallback;
